var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
var CSRF_HEADER_NAME = 'X-CSRF-TOKEN';
export var PAGE_CSRF_COOKIE_NAME = '__Host-X-PROFILE-CSRF-TOKEN';
export var addCsrfTokenHeader = function (csrfToken, headers) {
    var _a;
    if (headers === void 0) { headers = {}; }
    return (__assign(__assign({}, headers), (_a = {}, _a[CSRF_HEADER_NAME] = csrfToken, _a)));
};
export var getCsrfToken = function () {
    return Cookies.get(PAGE_CSRF_COOKIE_NAME) || '';
};
//# sourceMappingURL=csrf.js.map